const compatModules = {};import * as Mod1 from "./discourse/components/live-benchmark-runner";
compatModules["discourse/components/live-benchmark-runner"] = Mod1;

export * as discourse$components$live__benchmark__runner$$__module from "./discourse/components/live-benchmark-runner";
export {
default as discourse$components$live__benchmark__runner$$default
} from "./discourse/components/live-benchmark-runner";
import * as Mod2 from "./discourse/connectors/proxyviews-provider-benchmark/live-runner.gjs";
compatModules["discourse/connectors/proxyviews-provider-benchmark/live-runner"] = Mod2;

export * as discourse$connectors$proxyviews__provider__benchmark$live__runner$$__module from "./discourse/connectors/proxyviews-provider-benchmark/live-runner.gjs";
export {
default as discourse$connectors$proxyviews__provider__benchmark$live__runner$$default
} from "./discourse/connectors/proxyviews-provider-benchmark/live-runner.gjs";
import * as Mod3 from "./discourse/controllers/admin-plugins-proxyviews-benchmarks";
compatModules["discourse/controllers/admin-plugins-proxyviews-benchmarks"] = Mod3;

export * as discourse$controllers$admin__plugins__proxyviews__benchmarks$$__module from "./discourse/controllers/admin-plugins-proxyviews-benchmarks";
export {
default as discourse$controllers$admin__plugins__proxyviews__benchmarks$$default
} from "./discourse/controllers/admin-plugins-proxyviews-benchmarks";
import * as Mod4 from "./discourse/controllers/admin-plugins/proxyviews-benchmarks";
compatModules["discourse/controllers/admin-plugins/proxyviews-benchmarks"] = Mod4;

export * as discourse$controllers$admin__plugins$proxyviews__benchmarks$$__module from "./discourse/controllers/admin-plugins/proxyviews-benchmarks";
export {
default as discourse$controllers$admin__plugins$proxyviews__benchmarks$$default
} from "./discourse/controllers/admin-plugins/proxyviews-benchmarks";
import * as Mod5 from "./discourse/controllers/proxyviews-benchmarks-compare";
compatModules["discourse/controllers/proxyviews-benchmarks-compare"] = Mod5;

export * as discourse$controllers$proxyviews__benchmarks__compare$$__module from "./discourse/controllers/proxyviews-benchmarks-compare";
export {
default as discourse$controllers$proxyviews__benchmarks__compare$$default
} from "./discourse/controllers/proxyviews-benchmarks-compare";
import * as Mod6 from "./discourse/controllers/proxyviews-benchmarks";
compatModules["discourse/controllers/proxyviews-benchmarks"] = Mod6;

export * as discourse$controllers$proxyviews__benchmarks$$__module from "./discourse/controllers/proxyviews-benchmarks";
export {
default as discourse$controllers$proxyviews__benchmarks$$default
} from "./discourse/controllers/proxyviews-benchmarks";
import * as Mod7 from "./discourse/lib/benchmark-constants";
compatModules["discourse/lib/benchmark-constants"] = Mod7;

export * as discourse$lib$benchmark__constants$$__module from "./discourse/lib/benchmark-constants";
export {
TEST_TYPES as discourse$lib$benchmark__constants$$TEST_TYPES,
REGIONS as discourse$lib$benchmark__constants$$REGIONS,
PROTOCOLS as discourse$lib$benchmark__constants$$PROTOCOLS,
BLANK_NEW_RUN as discourse$lib$benchmark__constants$$BLANK_NEW_RUN
} from "./discourse/lib/benchmark-constants";
import * as Mod8 from "./discourse/lib/latency-tester";
compatModules["discourse/lib/latency-tester"] = Mod8;

export * as discourse$lib$latency__tester$$__module from "./discourse/lib/latency-tester";
export {
LatencyTester as discourse$lib$latency__tester$$LatencyTester
} from "./discourse/lib/latency-tester";
import * as Mod9 from "./discourse/proxyviews-benchmarks-route-map";
compatModules["discourse/proxyviews-benchmarks-route-map"] = Mod9;

export * as discourse$proxyviews__benchmarks__route__map$$__module from "./discourse/proxyviews-benchmarks-route-map";
export {
default as discourse$proxyviews__benchmarks__route__map$$default
} from "./discourse/proxyviews-benchmarks-route-map";
import * as Mod10 from "./discourse/routes/admin-plugins-proxyviews-benchmarks";
compatModules["discourse/routes/admin-plugins-proxyviews-benchmarks"] = Mod10;

export * as discourse$routes$admin__plugins__proxyviews__benchmarks$$__module from "./discourse/routes/admin-plugins-proxyviews-benchmarks";
export {
default as discourse$routes$admin__plugins__proxyviews__benchmarks$$default
} from "./discourse/routes/admin-plugins-proxyviews-benchmarks";
import * as Mod11 from "./discourse/routes/admin-plugins/proxyviews-benchmarks";
compatModules["discourse/routes/admin-plugins/proxyviews-benchmarks"] = Mod11;

export * as discourse$routes$admin__plugins$proxyviews__benchmarks$$__module from "./discourse/routes/admin-plugins/proxyviews-benchmarks";
export {
default as discourse$routes$admin__plugins$proxyviews__benchmarks$$default
} from "./discourse/routes/admin-plugins/proxyviews-benchmarks";
import * as Mod12 from "./discourse/routes/proxyviews-benchmarks-compare";
compatModules["discourse/routes/proxyviews-benchmarks-compare"] = Mod12;

export * as discourse$routes$proxyviews__benchmarks__compare$$__module from "./discourse/routes/proxyviews-benchmarks-compare";
export {
default as discourse$routes$proxyviews__benchmarks__compare$$default
} from "./discourse/routes/proxyviews-benchmarks-compare";
import * as Mod13 from "./discourse/routes/proxyviews-benchmarks";
compatModules["discourse/routes/proxyviews-benchmarks"] = Mod13;

export * as discourse$routes$proxyviews__benchmarks$$__module from "./discourse/routes/proxyviews-benchmarks";
export {
default as discourse$routes$proxyviews__benchmarks$$default
} from "./discourse/routes/proxyviews-benchmarks";
import * as Mod14 from "./discourse/templates/admin-plugins-proxyviews-benchmarks";
compatModules["discourse/templates/admin-plugins-proxyviews-benchmarks"] = Mod14;

export * as discourse$templates$admin__plugins__proxyviews__benchmarks$$__module from "./discourse/templates/admin-plugins-proxyviews-benchmarks";
export {
default as discourse$templates$admin__plugins__proxyviews__benchmarks$$default
} from "./discourse/templates/admin-plugins-proxyviews-benchmarks";
import * as Mod15 from "./discourse/templates/admin-plugins/proxyviews-benchmarks";
compatModules["discourse/templates/admin-plugins/proxyviews-benchmarks"] = Mod15;

export * as discourse$templates$admin__plugins$proxyviews__benchmarks$$__module from "./discourse/templates/admin-plugins/proxyviews-benchmarks";
export {
default as discourse$templates$admin__plugins$proxyviews__benchmarks$$default
} from "./discourse/templates/admin-plugins/proxyviews-benchmarks";
import * as Mod16 from "./discourse/templates/proxyviews-benchmarks-compare";
compatModules["discourse/templates/proxyviews-benchmarks-compare"] = Mod16;

export * as discourse$templates$proxyviews__benchmarks__compare$$__module from "./discourse/templates/proxyviews-benchmarks-compare";
export {
default as discourse$templates$proxyviews__benchmarks__compare$$default
} from "./discourse/templates/proxyviews-benchmarks-compare";
import * as Mod17 from "./discourse/templates/proxyviews-benchmarks";
compatModules["discourse/templates/proxyviews-benchmarks"] = Mod17;

export * as discourse$templates$proxyviews__benchmarks$$__module from "./discourse/templates/proxyviews-benchmarks";
export {
default as discourse$templates$proxyviews__benchmarks$$default
} from "./discourse/templates/proxyviews-benchmarks";
export default compatModules;
